import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../shared/services/user_service';
import { NoteService } from '../../shared/services/note_service';
import { StreamService } from '../../shared/services/stream_service';

import { Note } from '../../shared/types/note';
import { User } from '../../shared/types/user';
import { StreamKind } from '../../shared/types/stream_kind';
import { SubscriptionStatus } from '../types/subscription_status';

@Component({
    selector: 'threads',
    templateUrl: './threads.component.html',
    styleUrls: ['./threads.component.scss']
})
export class ThreadsComponent implements OnInit {
    @Input() note: Note;

    isNoteOwner = false;
    isStreamOwner = false;
    isInvited = false;
    isSubscribed = false;
    hasParents = false;
    parentNoteName: string;
    streamKind = StreamKind;

    constructor(
        private userService: UserService,
        private streamService: StreamService,
        private noteService: NoteService,
        private router: Router) {
    }

    public ngOnInit(): void {
        Promise.all([
            this.userService.getProfile(true),
            this.streamService.getSubscriptionStatus(this.note.channelId)
          ]).then((results: any) => {
            const user: User = results[0];
            const subscriptionStatus = results[1];

            this.isNoteOwner = (user.id.toString() === this.note.userId.toString()) ? true : false;
            this.isSubscribed = subscriptionStatus && subscriptionStatus.status === SubscriptionStatus.Active ? true : false;

            if (this.note.stream) {
                this.isStreamOwner = (user.id.toString() === this.note.stream.userId.toString()) ? true : false;
            } else {
                this.streamService.getStreamInfoObservable(this.note.channelId)
                    .subscribe(res => {
                        Object.assign(this.note, {
                            stream: res
                        });
                    });
            }
            this.checkInvitation(user.id);
          }), err => {
            console.error('There was an error while getting thread data. Please try again.', err);
          }
    }

    private checkInvitation(userId: string | number): void {
        if (this.note.debaters && this.note.debaters.filter(d => d === userId).length > 0) {
            this.isInvited = true;
        } else {
            if (this.note.parentPostId && this.note.parentPostId.length > 0) {
                const parentNoteId = this.note.parentPostId.toString();
                    this.noteService.getNoteInfo(parentNoteId, true)
                        .then((parentNote: Note) => {
                            this.hasParents = true;
                            this.parentNoteName = parentNote.name;
                            if (parentNote.debaters.filter(d => d === userId).length > 0) {
                                this.isInvited = true;
                            } else {
                                if (parentNote.parentPostId && parentNote.parentPostId.length > 0) {
                                    const grandParentNoteId = parentNote.parentPostId.toString();
                                        this.noteService.getNoteInfo(grandParentNoteId, true)
                                            .then(grandParentNote => {
                                                this.hasParents = true;
                                                this.parentNoteName = grandParentNote.name;
                                                if (grandParentNote.debaters.filter(d => d === userId).length > 0) {
                                                    this.isInvited = true;
                                                }
                                            });
                                }
                            }
                        })
                        .catch(err => {
                            console.error('Error while getting note id', parentNoteId, err);
                        });
            }
        }
    }

}
